import React from "react";
import { inject, observer } from "mobx-react";
import Streets from "./containers/StreetsContainer";

@inject("ApplicationModel")
@observer
class StreetsPage extends React.Component {
	componentDidMount() {
		let searcheModel = this.props.ApplicationModel.searcheModel;
		searcheModel.saveToMemoryData();
	}

	componentWillUnmount() {
		let searcheModel = this.props.ApplicationModel.searcheModel;
		if (!!searcheModel.getCurrentStreet().id) {
			searcheModel.deleteMemoryData();
		} else {
			searcheModel.recoveryMemoryData();
		}
	}

	render() {
		return <Streets ApplicationModel={this.props.ApplicationModel} route={this.props.route} />;
	}
}

export default StreetsPage;
